/** @jsx jsx */
import { jsx, Flex, Text } from 'theme-ui'
import { BrandLogoDesktop } from '../../icons/index'
import footerBackground from './footer-background.png'
import { graphql, useStaticQuery } from 'gatsby'
import ContactSection from './ContactSection'
import SocialSection from './SocialSection'
import ParseLink from '../common/ParseLink'

const GET_HOMEPAGE_FOOTER_DATA = graphql`
  query HomepageFooterSection {
    contentfulPageLayout(title: { eq: "Homepage" }) {
      contentModules {
        ... on ContentfulFooterSection {
          navSection {
            navLink {
              id
              title
              slug
            }
          }
          contact {
            id
            location
            address1
            address2
            tollFreeNumber
            phoneNumber
            faxNumber
          }
          socialLink {
            id
            socialPlatform
            link
          }
          disclosure
        }
      }
    }
  }
`

const MainFooter = () => {
  const { contentfulPageLayout } = useStaticQuery(GET_HOMEPAGE_FOOTER_DATA)
  const contentfulFooterSection = contentfulPageLayout?.contentModules?.filter(
    e => Object.keys(e).length !== 0
  )[0]

  const renderNavLinks = navLinks => {
    return navLinks.map(({ id, title, slug }) => (
      <ParseLink isMenuLink key={id} id={id} text={title} slug={slug} />
    ))
  }

  return (
    <div>
      <Flex
        sx={{
          display: 'flex',
          flexDirection: 'column',
          bg: 'forest',
          backgroundImage: `url(${footerBackground})`,
          backgroundSize: 'cover',
          py: 7,
          px: [4, 4, 8],
        }}
      >
        <BrandLogoDesktop sx={{ mt: 4 }} />
        <Flex
          sx={{
            flexDirection: ['column', 'row'],
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            mt: 7,
          }}
        >
          <nav
            aria-label="secondary"
            sx={{
              width: ['100%', '60%', '50%', '100%'],
              display: 'flex',
              flexDirection: ['column', 'column', 'column', 'row'],
            }}
          >
            <Flex
              variant="navLinks"
              sx={{
                flexDirection: 'column',
                justifyContent: 'flex-start',
                mr: [0, 6],
                maxHeight: '150px',
                width: ['100%', '100%', '100%', 'auto'],
                ':last-child': {
                  maxHeight: '150px',
                },
              }}
            >
              {contentfulFooterSection?.navSection?.navLink &&
                renderNavLinks(
                  contentfulFooterSection.navSection.navLink.slice(0, 5)
                )}
            </Flex>
            <Flex
              variant="navLinks"
              sx={{
                flexDirection: 'column',
                flexStart: 'flex-end',
                mr: 0,
                ml: 0,
                maxHeight: '150px',
                flexWrap: 'wrap',
              }}
            >
              {contentfulFooterSection?.navSection?.navLink &&
                renderNavLinks(
                  contentfulFooterSection.navSection.navLink.slice(
                    5,
                    contentfulFooterSection.navSection.navLink.length
                  )
                )}
            </Flex>
          </nav>
          <ContactSection contacts={contentfulFooterSection?.contact} />
        </Flex>
        <SocialSection socialLinks={contentfulFooterSection?.socialLink} />
      </Flex>
      <Flex
        sx={{
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: ['center'],
          py: 4,
          px: [4, 4, 8],
          bg: 'forest80',
          height: 96,
        }}
      >
        <Text variant="xxSmallText" sx={{ color: 'white' }}>
          {contentfulFooterSection?.disclosure}
        </Text>
      </Flex>
    </div>
  )
}

export default MainFooter
